import { listMaterials } from '@/lib/api'
import { useAsyncData } from '@/lib/useAsyncData'

export function StudentMaterialsPage() {
  const { data, error, loading } = useAsyncData(listMaterials, [])

  return (
    <div className="space-y-6 p-8">
      <h1 className="text-2xl font-bold text-slate-800">Materials</h1>
      {loading && <p className="text-sm text-slate-500">Loading…</p>}
      {error && <p className="rounded-xl bg-red-50 px-4 py-3 text-sm text-red-700">{error}</p>}
      <div className="space-y-3">
        {(data || []).map((m) => {
          const href = m.external_link || m.file || undefined
          return (
            <div
              key={m.id}
              className="flex items-center justify-between rounded-2xl border border-slate-100 bg-white p-5 shadow-sm"
            >
              <div>
                <p className="text-sm font-bold text-slate-800">{m.title}</p>
                <p className="text-xs text-slate-500">
                  {m.course_title} ({m.course_code}) · {m.module_title}
                </p>
              </div>
              {href ? (
                <a
                  href={href}
                  target="_blank"
                  rel="noreferrer"
                  className="rounded-xl bg-blue-600 px-4 py-2 text-xs font-semibold text-white"
                >
                  Open
                </a>
              ) : (
                <span className="text-xs text-slate-400">No file</span>
              )}
            </div>
          )
        })}
      </div>
      {!loading && (data || []).length === 0 && (
        <p className="text-sm text-slate-500">No learning materials yet.</p>
      )}
    </div>
  )
}
